'use strict';

Object.defineProperty(exports, "__esModule", {
              value: true
});

var _client = require('feathers/client');

var _client2 = _interopRequireDefault(_client);

var _feathersHooks = require('feathers-hooks');

var _feathersHooks2 = _interopRequireDefault(_feathersHooks);

var _client3 = require('feathers-rest/client');

var _client4 = _interopRequireDefault(_client3);

var _client5 = require('feathers-authentication/client');

var _client6 = _interopRequireDefault(_client5);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rest = (0, _client4.default)(window.location.origin);
var client = (0, _client2.default)().configure((0, _feathersHooks2.default)()).configure((0, _client6.default)({ storage: localStorage })).configure(rest.superagent(_superagent2.default));

exports.default = client;


//////////////////
// WEBPACK FOOTER
// ./client/client.js
// module id = 16
// module chunks = 0